import { decode } from 'html-entities'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Select from 'react-select'
import { getCurrencySign, isInPhoneScreen } from '../../utils/utils'
import { withAuth } from '../AuthContext'
import Button from '../Utils/Button'
import Error from '../Utils/Error'
import Paypal from './Paypal'
import { gaEvents } from '../../analytics/events'
import { Box, Slider } from '@mui/material'

import { textTranslation, shouldTranslateTo } from '../../utils/utils'

import styled from 'styled-components'

import {
  Title,
  Subtitle,
  GreenBoldSub,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'
import { BackButton } from '../Utils/CustomComponents'

const Container = styled.section`
  background-color: #f3f4f6;
  margin: 60px 0;

  @media (max-width: 767px) {
    margin: 30px 0;
  }
`

const ContainerBox = styled.div`
  padding: 45px 60px 5px 60px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 20px 5px 20px;
  }
`

const Group = styled.div`
  padding: 20px 0 0 0 !important;
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 80px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 140px;
`

class ChooseMembershipFee extends Component {
  constructor(props) {
    super(props)
    const u = this.props.auth.user
    this.state = {
      defaultMembershipFee: '35',
      savedMembershipFee: u.membershipFee,
      membershipFee: u.membershipFee,
      membershipFeeStatus: null,
      currencySign: null,
      loading: false,
      error: '',
      checkout: false,
      value: '35',
      pageText: [],
    }
    this.handleMembershipFeeChange = this.handleMembershipFeeChange.bind(this)
    this.valuetext = this.valuetext.bind(this)
    this.valueLabelFormat = this.valueLabelFormat.bind(this)
  }

  componentDidMount() {
    const getCurrency = async () => {
      const data = await getCurrencySign(this.props.auth.user.currencyValue)
      this.setState({
        currencySign: data.sign,
      })
    }
    getCurrency()

    if (this.state.membershipFee !== null) {
      this.setState({
        value: this.state.membershipFee,
      })
    } else {
      this.setState({
        value: this.state.defaultMembershipFee,
        membershipFee: this.state.defaultMembershipFee,
      })
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          this.setState({
            pageText: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-pay', language)
  }

  handleMembershipFeeChange(value) {
    gaEvents.eventGeneric(
      'button_click',
      'price-dropdown-updated',
      this.props.auth.user.id +
        ' - choose membership fee - drop down menu - price chosen'
    )
    const membershipFee = value

    if (membershipFee < 5) {
      this.setState({
        membershipFee: 1,
        savedMembershipFee: 1,
        value: 1,
        error: '',
      })
    } else {
      this.setState({
        membershipFee: membershipFee,
        savedMembershipFee: membershipFee,
        value: membershipFee,
        error: '',
      })
    }
  }

  handleChooePaypal() {
    gaEvents.eventGeneric(
      'button_click',
      'paypal-chosen',
      this.props.auth.user.id +
        ' - choose membership fee - button - choose Paypal'
    )
    this.setState({ membershipFeeStatus: 'pending' }, () => {
      this.props.auth.updateUser(this.state).then(() => {
        this.setState({
          checkout: true,
        })
      })
    })
  }

  valuetext(value) {
    return `${value}`
  }

  valueLabelFormat(value) {
    return decode(this.state.currencySign) + value.toString()
  }

  async handleSubmit(e) {
    gaEvents.eventGeneric(
      'button_click',
      'stripe-chosen',
      this.props.auth.user.id +
        ' - choose membership fee - button - choose Stripe'
    )

    this.setState({
      loading: true,
      error: '',
    })

    if (this.state.membershipFee === '' || this.state.membershipFee === null) {
      this.setState({
        loading: false,
        error: 'Please choose a membership fee option',
      })
      return
    }

    var membershipFeeStatus = ''
    var pushLocation = ''

    if (this.state.membershipFee === 0) {
      membershipFeeStatus = 'completed'
      pushLocation = '/dashboard'
    } else {
      membershipFeeStatus = 'pending'
      pushLocation = '/dashboard/payc-fee'
    }

    this.setState({ membershipFeeStatus: membershipFeeStatus }, () => {
      this.props.auth.updateUser(this.state).then(() => {
        const that = this
        setTimeout(function () {
          if (that.state.membershipFee === 0) {
            window.open('/dashboard', '_self')
          } else {
            that.props.history.push('/dashboard/payc-fee')
          }
        }, 2000)
      })
    })
  }

  render() {
    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '0',
        width: '100%',
        marginBottom: '10px',
        flexWrap: 'nowrap',
        maxWidth: '500px',
        outline: `${isInPhoneScreen ? '1px solid lightgray' : 'none'} `,
        border: 'none',
      }),
    }

    const marks = [
      {
        value: 1,
        label: decode(this.state.currencySign) + '1',
      },
      {
        value: 20,
        label: decode(this.state.currencySign) + '20',
      },
      {
        value: 40,
        label: decode(this.state.currencySign) + '40',
      },
      {
        value: 60,
        label: decode(this.state.currencySign) + '60',
      },
      {
        value: 80,
        label: decode(this.state.currencySign) + '80',
      },
      {
        value: 100,
        label: decode(this.state.currencySign) + '100',
      },
    ]

    if (!this.state.currencySign || this.state.pageText.length === 0) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ marginTop: '100px' }}
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )
    }
    return (
      <Container className="edit-profile choose-membership-fee">
        <div className="container">
          <div className="row justify-content-center">
            <div className={`${isInPhoneScreen ? '' : 'col-md-8'} `}>
              {this.state.checkout ? (
                <div>
                  <div>
                    <Paypal
                      user={this.props.auth.user}
                      membershipFee={this.state.membershipFee}
                      currencySign={this.props.auth.user.currencyValue}
                    />
                  </div>
                  <div className="text-center" style={{ marginTop: '15px' }}>
                    <button
                      type="button"
                      className="btn btn-danger text-decoration-none"
                      onClick={() => {
                        this.setState({
                          checkout: false,
                        })
                      }}
                    >
                      Back
                    </button>
                  </div>
                </div>
              ) : (
                <ContainerBox className="contact_form">
                  <BackButton link="/dashboard" text={this.state.pageText[0]} />

                  <form
                    method="POST"
                    action="/"
                    name="myForm"
                    aria-label="Add Profile"
                    onSubmit={(event) => {
                      event.preventDefault()
                      return false
                    }}
                  >
                    <input
                      type="hidden"
                      name="csrf-token"
                      value={window.Laravel.csrfToken}
                    />

                    <Group className="col-12 form-group">
                      <Title size="38px" bold margin="20px 0 30px 0">
                        {this.state.pageText[1]}{' '}
                      </Title>
                      <GreenBoldSub
                        size="18px"
                        dangerouslySetInnerHTML={{
                          __html: `${
                            this.state.pageText[2] +
                            ' ' +
                            this.state.currencySign +
                            this.state.pageText[3] +
                            ' ' +
                            this.state.currencySign +
                            this.state.pageText[4]
                          }`,
                        }}
                      ></GreenBoldSub>
                      <Subtitle size="20px" bold margin="48px 0 0 0">
                        {this.state.pageText[5]}
                      </Subtitle>
                      <div className="price-slider-container">
                        <Box>
                          <Slider
                            valueLabelFormat={this.valueLabelFormat}
                            getAriaValueText={this.valuetext}
                            value={this.state.value}
                            step={5}
                            valueLabelDisplay="on"
                            marks={marks}
                            min={0}
                            size="large"
                            onChange={(_, newValue) =>
                              this.handleMembershipFeeChange(newValue)
                            }
                          />
                        </Box>
                      </div>
                    </Group>

                    <FlexRow>
                      {this.state.loading ? (
                        <LoadingButton padding="11px 35px 11px 43px">
                          {this.state.savedMembershipFee !== null
                            ? this.state.pageText[6] +
                              decode(this.state.currencySign) +
                              this.state.membershipFee +
                              ' ' +
                              this.state.pageText[7]
                            : this.state.pageText[6] +
                              decode(this.state.currencySign) +
                              this.state.defaultMembershipFee +
                              ' ' +
                              this.state.pageText[7]}
                        </LoadingButton>
                      ) : (
                        <ActionButtons
                          padding="11px 35px"
                          onClick={() => {
                            this.handleSubmit()
                          }}
                        >
                          <img src="/images/icons/card.svg" />{' '}
                          {this.state.savedMembershipFee !== null
                            ? this.state.pageText[6] +
                              decode(this.state.currencySign) +
                              this.state.membershipFee +
                              ' ' +
                              this.state.pageText[7]
                            : this.state.pageText[6] +
                              decode(this.state.currencySign) +
                              this.state.defaultMembershipFee +
                              ' ' +
                              this.state.pageText[7]}
                        </ActionButtons>
                      )}

                      <ActionButtons
                        blackText
                        padding="11px 35px"
                        background="#FCBB32"
                        onClick={() => {
                          this.handleChooePaypal()
                        }}
                      >
                        {this.state.savedMembershipFee !== null
                          ? this.state.pageText[6] +
                            decode(this.state.currencySign) +
                            this.state.membershipFee
                          : this.state.pageText[6] +
                            decode(this.state.currencySign) +
                            this.state.defaultMembershipFee}

                        <img src="/images/icons/paypal.svg" />
                      </ActionButtons>
                    </FlexRow>

                    <Center>
                      {isInPhoneScreen() ? (
                        <img
                          src="/images/icons/licensePaypal-mobile.svg"
                          alt=""
                        />
                      ) : (
                        <img src="/images/icons/licensePaypal.svg" alt="" />
                      )}
                    </Center>

                    <div className="form-error">
                      <Error error={this.state.error} />
                    </div>
                  </form>
                </ContainerBox>
              )}
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

export default withRouter(withAuth(ChooseMembershipFee))
